<template>
  <div class="hero-auto">
    <div class="hero-nav">
      <div class="hero-nav-content">
        <router-link to="/" class="hero-logo">
          <h1 class="hero-logo-text">ARŪNVILKASA</h1>
          <h5 class="hero-logo-subtitle">Autoservizas</h5>
        </router-link>
        <nav class="hero-nav-menu">
          <a @click.prevent="scrollTo('ourAdvantages')" class="hero-nav-link">Apie mus</a>
          <a @click.prevent="scrollTo('outServices')" class="hero-nav-link">Paslaugos</a>
          <a @click.prevent="scrollTo('contact')" class="hero-nav-link">Kontaktai</a>
        </nav>
        <button 
          class="mobile-menu-toggle" 
          @click="toggleMobileMenu"
          aria-label="Atidaryti meniu"
        >
          <span class="hamburger-line" :class="{ 'active': isMobileMenuOpen }"></span>
          <span class="hamburger-line" :class="{ 'active': isMobileMenuOpen }"></span>
          <span class="hamburger-line" :class="{ 'active': isMobileMenuOpen }"></span>
        </button>
      </div>
    </div>
    
    <!-- Mobile Menu -->
    <div class="mobile-menu" :class="{ 'open': isMobileMenuOpen }">
      <nav class="mobile-nav">
        <a @click.prevent="closeMenuAndScroll('ourAdvantages')" class="mobile-nav-link">Apie mus</a>
        <a @click.prevent="closeMenuAndScroll('outServices')" class="mobile-nav-link">Paslaugos</a>
        <a @click.prevent="closeMenuAndScroll('contact')" class="mobile-nav-link">Kontaktai</a>
      </nav>
    </div>
    
    <div class="hero-content-auto">
      <div class="hero-main-auto">
        <h1 class="hero-title-auto">AUTOMOBILIŲ SERVISAS IR REMONTAS</h1>
        <div class="hero-divider-auto"></div>
        <p class="hero-subtitle-auto">Profesionalus automobilių remontas ir aptarnavimas. Kokybiškos paslaugos jūsų automobiliui.</p>
        
        <!-- CTA Buttons -->
        <div class="hero-actions-auto">
          <a href="tel:+37061692311" class="btn-hero-primary-auto">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <span>SUSISIEKTI</span>
          </a>
          <button @click="scrollTo('outServices')" class="btn-hero-secondary-auto">
            <span>MŪSŲ PASLAUGOS</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {nextTick, ref} from "vue";

export default {
  name: "HeroHeader",
  setup() {
    const isMobileMenuOpen = ref(false);

    const scrollTo = (id) => {
      nextTick(() => {
        document.getElementById(id).scrollIntoView({
          behavior: "smooth"
        });
      })
    }

    const toggleMobileMenu = () => {
      isMobileMenuOpen.value = !isMobileMenuOpen.value;
    }

    const closeMenuAndScroll = (id) => {
      isMobileMenuOpen.value = false;
      scrollTo(id);
    }

    return {
      scrollTo,
      isMobileMenuOpen,
      toggleMobileMenu,
      closeMenuAndScroll,
    }
  }
}
</script>

<style scoped>
.hero-auto {
  background-image: url('../../assets/headerbg.jpeg');
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  position: relative;
}

.hero-auto::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 0;
}

.hero-auto > * {
  position: relative;
  z-index: 1;
}

.hero-nav {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 20px;
  z-index: 10;
}

.hero-nav-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hero-logo {
  text-decoration: none;
  color: white;
  display: inline-block;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
}

.hero-logo:hover {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  transform: translateY(-2px);
}

.hero-logo::after {
  content: '← Grįžti';
  position: absolute;
  left: 100%;
  margin-left: 12px;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  transform: translateX(-10px);
  white-space: nowrap;
  color: #ff6b6b;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
}

.hero-logo:hover::after {
  opacity: 1;
  transform: translateX(0);
}

.hero-logo-text {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 800;
  margin: 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  letter-spacing: 0.05em;
  transition: color 0.3s ease;
}

.hero-logo:hover .hero-logo-text {
  color: #ff6b6b;
}

.hero-logo-subtitle {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(0.8rem, 1.5vw, 1rem);
  font-weight: 600;
  margin: 0;
  opacity: 0.9;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

.hero-logo:hover .hero-logo-subtitle {
  opacity: 1;
}

.hero-nav-menu {
  display: flex;
  gap: 24px;
  align-items: center;
}

.hero-nav-link {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(0.9rem, 1.5vw, 1.1rem);
  font-weight: 600;
  color: white;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  padding: 8px 0;
  position: relative;
}

.hero-nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
  transition: width 0.3s ease;
}

.hero-nav-link:hover {
  color: #ff6b6b;
  text-decoration: none;
}

.hero-nav-link:hover::after {
  width: 100%;
}

.hero-content-auto {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 120px 20px 40px;
}

.hero-main-auto {
  max-width: 900px;
  text-align: center;
  width: 100%;
}

.hero-title-auto {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: 800;
  color: white;
  margin-bottom: 24px;
  line-height: 1.2;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  letter-spacing: -0.02em;
}

.hero-divider-auto {
  width: 100px;
  height: 4px;
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
  margin: 0 auto 30px;
  border-radius: 2px;
  box-shadow: 0 2px 10px rgba(220, 53, 69, 0.5);
}

.hero-subtitle-auto {
  font-family: 'Open Sans', sans-serif;
  font-size: clamp(1rem, 2.5vw, 1.3rem);
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 40px;
  line-height: 1.6;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.hero-actions-auto {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 40px;
}

.btn-hero-primary-auto {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  color: white;
  padding: 18px 48px;
  border-radius: 50px;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  box-shadow: 0 8px 25px rgba(220, 53, 69, 0.5);
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}

.btn-hero-primary-auto:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 12px 35px rgba(220, 53, 69, 0.6);
  color: white;
  text-decoration: none;
}

.btn-hero-primary-auto svg {
  width: 24px;
  height: 24px;
}

.btn-hero-secondary-auto {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  color: white;
  padding: 18px 48px;
  border-radius: 50px;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
}

.btn-hero-secondary-auto:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.3);
}

.btn-hero-secondary-auto svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.btn-hero-secondary-auto:hover svg {
  transform: translateY(3px);
}

/* Mobile Menu Toggle Button */
.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1001;
}

.mobile-menu-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}

.hamburger-line {
  width: 25px;
  height: 3px;
  background: white;
  border-radius: 2px;
  transition: all 0.3s ease;
  transform-origin: center;
}

.mobile-menu-toggle:hover .hamburger-line {
  background: #ff6b6b;
}

.hamburger-line.active:nth-child(1) {
  transform: rotate(45deg) translate(7px, 7px);
}

.hamburger-line.active:nth-child(2) {
  opacity: 0;
}

.hamburger-line.active:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -7px);
}

/* Mobile Menu */
.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(10px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.mobile-menu.open {
  opacity: 1;
  visibility: visible;
}

.mobile-nav {
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  transform: translateY(-20px);
  transition: transform 0.3s ease;
}

.mobile-menu.open .mobile-nav {
  transform: translateY(0);
}

.mobile-nav-link {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 10px 20px;
  border-radius: 8px;
  position: relative;
}

.mobile-nav-link:hover {
  color: #ff6b6b;
  background: rgba(255, 255, 255, 0.1);
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .hero-nav-menu {
    display: none;
  }
  
  .mobile-menu-toggle {
    display: flex;
  }
  
  .hero-content-auto {
    padding: 100px 15px 40px;
  }
  
  .btn-hero-primary-auto,
  .btn-hero-secondary-auto {
    padding: 16px 36px;
    font-size: 1rem;
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }
  
  .hero-actions-auto {
    flex-direction: column;
    align-items: center;
  }

  /* Fix background-attachment on mobile */
  .hero-auto {
    background-attachment: scroll;
  }
}
</style>